import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { LayoutGrid, LogOut } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useAuth } from "@/context/AuthContext";
import { mobileTabs, flatNav } from "./navItems";
import { cn } from "@/lib/utils";

export default function MobileNav() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const go = (to) => { setOpen(false); navigate(to); };
  const tabs = mobileTabs(user);

  return (
    <>
      <nav data-testid="mobile-bottom-nav" className="fixed inset-x-0 bottom-0 z-40 border-t-2 border-ink bg-white/95 backdrop-blur-md md:hidden"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
        <div className="grid" style={{ gridTemplateColumns: `repeat(${tabs.length + 1}, minmax(0,1fr))` }}>
          {tabs.map((t) => (
            <NavLink key={t.key} to={t.to} end={t.to === "/"} data-testid={`mobile-nav-${t.key}`}
              className={({ isActive }) => cn("press relative flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-medium", isActive ? "text-brand" : "text-zinc-600")}>
              {({ isActive }) => (
                <>
                  {isActive && <span className="absolute top-0 h-[3px] w-10 rounded-b bg-brand" />}
                  <t.icon className="h-5 w-5" strokeWidth={isActive ? 2.2 : 1.8} />
                  {t.label}
                </>
              )}
            </NavLink>
          ))}
          <button onClick={() => setOpen(true)} data-testid="mobile-nav-menu" className="press flex h-16 flex-col items-center justify-center gap-1 text-[11px] font-medium text-zinc-600">
            <LayoutGrid className="h-5 w-5" strokeWidth={1.8} /> Menu
          </button>
        </div>
      </nav>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="bottom" className="max-h-[85vh] overflow-y-auto rounded-t-2xl border-t-2 border-ink" data-testid="mobile-menu-sheet">
          <SheetHeader>
            <SheetTitle className="text-left font-display">Menu · {user?.name}</SheetTitle>
          </SheetHeader>
          <div className="mt-4 grid grid-cols-3 gap-2">
            {flatNav(user).map((n) => (
              <button key={n.key} onClick={() => go(n.to)} data-testid={`mobile-menu-${n.key}`}
                className="press flex flex-col items-center gap-2 rounded-lg border border-zinc-200 bg-white p-3 text-center text-xs font-medium hover:border-ink">
                <n.icon className="h-6 w-6" strokeWidth={1.6} />
                {n.label}
              </button>
            ))}
          </div>
          <button onClick={logout} data-testid="mobile-logout-btn" className="press mt-4 flex w-full items-center justify-center gap-2 rounded-lg border-2 border-ink py-3 text-sm font-semibold">
            <LogOut className="h-4 w-4" /> Keluar
          </button>
        </SheetContent>
      </Sheet>
    </>
  );
}
